export default __webpack_public_path__ + "static/youngChild-609e457521469d17e440a4c0080ff9f3.svg";